import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { QuestionAnswer } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const InputNode = memo(({ id, data, isConnectable, selected }) => {
  const question = data?.question || data?.message;
  const variableName = data?.variableName;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<QuestionAnswer />}
      title="Captura de Entrada"
      color="#9c27b0"
      bgColor="#FAF5FF"
      isConnectable={isConnectable}
      selected={selected}
    >
      {/* Question preview */}
      {question && (
        <div
          style={{
            fontSize: 11,
            color: "#444",
            lineHeight: 1.4,
            marginBottom: 6,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            maxWidth: 200,
          }}
        >
          {question}
        </div>
      )}

      {/* Variable chip */}
      {variableName && (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            padding: "3px 8px",
            borderRadius: 6,
            fontSize: 10,
            fontWeight: 600,
            fontFamily: "'JetBrains Mono', 'Fira Code', 'Consolas', monospace",
            backgroundColor: "#F3E5F5",
            color: "#7B1FA2",
            border: "1px solid #CE93D8",
            marginBottom: data?.alwaysAsk != null ? 4 : 0,
          }}
        >
          <span style={{ color: "#9c27b0", fontSize: 9, fontWeight: 400 }}>var</span>
          {variableName}
        </div>
      )}

      {/* Always ask toggle */}
      {data?.alwaysAsk != null && (
        <div
          style={{
            fontSize: 10,
            color: data.alwaysAsk ? "#7B1FA2" : "#999",
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: data.alwaysAsk ? "#9c27b0" : "#ccc",
              display: "inline-block",
              flexShrink: 0,
            }}
          />
          {data.alwaysAsk ? "Sempre perguntar" : "Perguntar uma vez"}
        </div>
      )}
    </NodeWrapper>
  );
});

InputNode.displayName = "InputNode";
export default InputNode;
